document.addEventListener("DOMContentLoaded", function () {
  const timers = document.querySelectorAll(".countdown-timer");

  timers.forEach((timer) => {
    const endTime = timer.getAttribute("data-end-time");
    if (!endTime) return;

    const endDate = parseInt(endTime, 10);
    const daysEl = timer.querySelector(".countdown-timer-days");
    const hoursEl = timer.querySelector(".countdown-timer-hours");
    const minutesEl = timer.querySelector(".countdown-timer-minutes");
    const secondsEl = timer.querySelector(".countdown-timer-seconds");

    function updateTimer() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        clearInterval(interval);
        timer.style.display = "none"; // Or handle expiration differently
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.innerHTML = `${formatNumber(days)} <span>Days</span>`;
      if (hoursEl)
        hoursEl.innerHTML = `${formatNumber(hours)} <span>Hours</span>`;
      if (minutesEl)
        minutesEl.innerHTML = `${formatNumber(minutes)} <span>Minutes</span>`;
      if (secondsEl)
        secondsEl.innerHTML = `${formatNumber(seconds)} <span>Seconds</span>`;
    }

    function formatNumber(num) {
      return num < 10 ? `0${num}` : num;
    }

    updateTimer(); // Run immediately
    const interval = setInterval(updateTimer, 1000);
  });
});